import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';

import { EmbryoService } from '../../Services/Embryo.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'embryo-BrandsLogo',
  templateUrl: './BrandsLogo.component.html',
  styleUrls: ['./BrandsLogo.component.scss']
})
export class BrandslogoComponent implements OnInit, OnChanges {

   @Input() isRTL : BehaviorSubject<any> = new BehaviorSubject<any>(null);
   isRTL$:boolean;
   slideConfig : any;

   brandsLogoArray : any = [
      {
         id:1,
         image:"assets/images/client-logo-1.png"
      },
      {
         id:2,
         image:"assets/images/client-logo-2.png"
      },
      {
         id:3,
         image:"assets/images/client-logo-3.png"
      },
      {
         id:4,
         image:"assets/images/client-logo-4.png"
      },
      {
         id:5,
         image:"assets/images/client-logo-2.png"
      },
      {
         id:6,
         image:"assets/images/client-logo-1.png"
      },
      {
         id:7,
         image:"assets/images/client-logo-3.png"
      },

   ]

   constructor(public embryoService : EmbryoService) { 
      this.isRTL.asObservable().subscribe(x=>this.isRTL$ = x);
   }

   ngOnInit() {
   }

   ngOnChanges() {
      this.slideConfig = {
         infinite: true,
         centerMode: true,
         slidesToShow: 5,
         slidesToScroll: 2,
         autoplay: true,
         autoplaySpeed: 2000,
         rtl: this.isRTL$,
         responsive: [
            {
               breakpoint: 768,
               settings: {
                  centerMode: true,
                  slidesToShow: 4,
                  slidesToScroll: 2,
                  autoplay: true,
                  autoplaySpeed: 2000
               }
            },
            {
               breakpoint: 480,
               settings: {
                  centerMode: true,
                  slidesToShow: 1,
                  autoplay: true,
                  autoplaySpeed: 2000
               }
            }
         ]
      };
   }

   

}
